import { root } from './uploadurls';

export const uploadurls = {
  ...root,
};
